import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { preventImageTheftProps } from '../../common/helpers/imageHelper'
import HotelNotFoundImage from '../../../../assets/images/voc/graphics/hotel-default-image.svg'

const Image = ({ src, text, children, cropped, captioned, ...rest }) => {
  const [defaultClass, setDefaultClass] = useState(null)
  const { errorHandlerCallback, ...props } = rest

  const errorHandler = (e) => {
    let imageEl = e

    if(errorHandlerCallback) {
      return errorHandlerCallback(imageEl.currentTarget)
    }

    imageEl.currentTarget.src = HotelNotFoundImage
    setDefaultClass(true)
  }

  return (
    <figure className={`image ${cropped && 'cropped'} ${captioned ? 'captioned' : ''} ${defaultClass ? 'default' : ''}`}>
      <img src={src}
        alt={text}
        onError={errorHandler}
        {...preventImageTheftProps}
        {...props}
        />
      { children || text && <figcaption>{children || text}</figcaption> }
    </figure>
  )
}

Image.defaultProps = {
  src: HotelNotFoundImage,
  alt: 'voc default image',
  cropped: true,
  captioned: false
}

Image.propTypes = {
  src: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.node,
  cropped: PropTypes.bool,
  captioned: PropTypes.bool,
}

export default Image
